import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { InfoTooltip } from '@/shared/components/Tooltip';

interface Props {
  titleId?: string;
  tooltipId?: string;
  children: ReactNode;
}

export default function ScheduleSectionBlock({ titleId, tooltipId, children }: Props) {
  const hasTitle = Boolean(titleId);

  return (
    <div className="border-t border-slate-200/80 pt-3 first:border-t-0 first:pt-0">
      {hasTitle && (
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-slate-400">
          <FormattedMessage id={titleId} />
          {tooltipId && (
            <InfoTooltip content={<FormattedMessage id={tooltipId} />} />
          )}
        </div>
      )}
      <div className={`text-sm text-slate-600 ${hasTitle ? 'mt-3 space-y-1.5' : 'space-y-1.5'}`}>
        {children}
      </div>
    </div>
  );
}
